export const dataFieldsRootId = 'dataFields';
export function isNodeInsideDataGroup(item) {
  return item?.nodeType === 'dataField';
}
export function generateTargetForField(target, isDataField) {
  return isDataField ? `#${dataFieldsRootId}.${target}` : `${target}`;
}